import React from 'react';
import { Input, Select } from '@/components/ui';
import type { UserEditFormData } from '../types/userEdit.types';

interface Props {
  formData: UserEditFormData;
  updateField: (field: keyof UserEditFormData, value: any) => void;
}

const ROLES = [
  { value: 'admin', label: 'Quản trị viên' },
  { value: 'pm', label: 'Quản lý dự án' },
  { value: 'supervisor', label: 'Giám sát thi công' },
  { value: 'technician', label: 'Kỹ thuật viên' },
  { value: 'staff', label: 'Nhân viên' }
];

const SKILLS_LIST = [
  'Cắt tỉa', 'Tưới tiêu', 'Bón phân', 'Pha thuốc', 'Bảo trì máy', 'Lái xe tải', 'Thiết kế 2D', 'Quản lý kho'
];

export function EditWorkInfo({ formData, updateField }: Props) {
  const toggleSkill = (skill: string) => {
    const currentSkills = formData.skills || [];
    if (currentSkills.includes(skill)) {
      updateField('skills', currentSkills.filter(s => s !== skill));
    } else {
      updateField('skills', [...currentSkills, skill]);
    }
  };

  return (
    <div className="bg-white rounded-md p-6 border border-slate-100 w-full h-full">
      <h2 className="sm:text-sm text-xs font-medium text-slate-800 mb-6">Công việc & Năng lực</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Vai trò hệ thống"
          value={formData.role_code || ''}
          onValueChange={(val: any) => updateField('role_code', val)}
          options={ROLES}
        />
        <Input
          label="Chức danh/Vị trí"
          placeholder="VD: Kỹ sư cảnh quan"
          value={formData.job_title || ''}
          onChange={(e: any) => updateField('job_title', e.target.value)}
        />
        <Select
          label="Trình độ học vấn"
          value={formData.education_level || ''}
          onValueChange={(val: any) => updateField('education_level', val)}
          options={[
            { value: '', label: 'Chưa cập nhật' },
            { value: 'Đại học', label: 'Đại học' },
            { value: 'Cao đẳng', label: 'Cao đẳng' },
            { value: 'Trung cấp', label: 'Trung cấp' },
            { value: 'Phổ thông', label: 'Phổ thông' },
          ]}
        />
        
        <div className="md:col-span-2">
          <label className="block sm:text-sm text-xs font-medium text-slate-700 mb-2">
            Kỹ năng chuyên môn
          </label>
          <div className="flex flex-wrap gap-2">
            {SKILLS_LIST.map((skill) => {
              const isSelected = formData.skills?.includes(skill);
              return (
                <button
                  key={skill}
                  type="button"
                  onClick={() => toggleSkill(skill)}
                  className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
                    isSelected 
                      ? 'bg-emerald-100 text-emerald-700 border border-emerald-200' 
                      : 'bg-slate-50 text-slate-500 border border-slate-200 hover:bg-slate-100'
                  }`}
                >
                  {skill}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
